import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import App from './components/App';
import GlobalStyle from './style/global';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const DesktopAlertOverlay = styled.div`
  display: none;
  @media (min-width: 1024px) {
    display: flex;
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    background: radial-gradient(circle at top right, #4158d0 0%, #506ac8ff 46%, #7570ffff 100%);
    background-attachment: fixed;
    z-index: 2147483647;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-family: 'Inter', sans-serif;
  }
`;

const DesktopAlertCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-radius: 24px;
  padding: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.15);
  max-width: 420px;
  width: 100%;
`;

const DesktopAlertIcon = styled.div`
  margin-bottom: 24px;
  background: rgba(255, 255, 255, 0.15);
  padding: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  svg {
    width: 64px;
    height: 64px;
    fill: #ffffff;
  }
`;

const DesktopAlertTitle = styled.h2`
  font-size: 28px;
  color: #ffffff;
  margin-bottom: 16px;
  font-weight: 600;
`;

const DesktopAlertMessage = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.85);
`;

const AppContainer = styled.div`
  width: 100%;
  height: 100%;
  @media (min-width: 1024px) {
    display: none;
  }
`;

ReactDOM.render(
  <Wrapper>
    <GlobalStyle />
    <DesktopAlertOverlay>
      <DesktopAlertCard>
        <DesktopAlertIcon>
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z" />
          </svg>
        </DesktopAlertIcon>
        <DesktopAlertTitle>Device Not Supported</DesktopAlertTitle>
        <DesktopAlertMessage>
          We suggest using a mobile or tablet device to enjoy the best experience.
        </DesktopAlertMessage>
      </DesktopAlertCard>
    </DesktopAlertOverlay>
    <AppContainer>
      <Provider store={store}>
        <App />
      </Provider>
    </AppContainer>
  </Wrapper>,
  document.getElementById('root'),
);
